import { RoleValidityRequest, RoleViewModel } from '@core/api';
import moment from 'moment';

/** Vorlauf in Tagen, ab dem eine auslaufende Rollenvergabe zum Verlaengern angeboten wird. */
export const ROLE_EXTENDABLE_WITHIN_DAYS = 30;

/**
 * Eine Vergabe darf verlaengert werden, sobald ihr Ende hinterlegt ist und
 * innerhalb der naechsten Tage liegt. Bereits abgelaufene Vergaben zaehlen
 * ebenfalls dazu, sie sind der dringendere Fall. Unbefristete Vergaben nicht.
 */
export const isRoleExtendable = (
  validUntil: Date | string | undefined
): boolean => {
  if (!validUntil) {
    return false;
  }

  return (
    moment(validUntil).startOf('day').valueOf() <=
    moment().add(ROLE_EXTENDABLE_WITHIN_DAYS, 'days').startOf('day').valueOf()
  );
};

/**
 * Eine Vergabe ist abgelaufen, sobald ihr letzter Gueltigkeitstag vorbei ist.
 * Das gilt auch, wenn der naechtliche Entzug die Rolle noch nicht entfernt hat.
 */
export const isRoleExpired = (validUntil: Date | string | undefined): boolean =>
  !!validUntil &&
  moment(validUntil).startOf('day').isBefore(moment().startOf('day'));

/**
 * Das Backend erwartet Gueltigkeiten als reines Datum. Ein Date-Objekt wuerde
 * als UTC-Zeitpunkt serialisiert und koennte dabei auf den Vortag rutschen.
 */
export const toDateOnlyString = (
  value: Date | string | undefined
): string | undefined =>
  value ? moment(value).format('YYYY-MM-DD') : undefined;

/** Gueltigkeiten der Rollen in der Form, die das Backend beim Speichern erwartet. */
export const toRoleValidityRequests = (
  roles: RoleViewModel[]
): RoleValidityRequest[] =>
  (roles ?? []).map(role => ({
    roleId: role.id,
    validFrom: toDateOnlyString(role.validFrom) as unknown as Date,
    validUntil: toDateOnlyString(role.validUntil) as unknown as Date,
  }));
